<template>
    <input @blur="focus = false" @focus="focus = true" :id="id" @input="input" ref="element" :value="value" />
</template>

<script setup>
    const props = defineProps({
        decorator: { default: (value) => value, type: Function },
        modelValue: { type: { Number, String } }
    });

    const focus = ref(false);
    const element = ref();
    const id = nextId();
    const value = ref(props.modelValue);

    const emit = defineEmits(["update:modelValue"]);

    const input = () => {
        emit("update:modelValue", element.value.value);
    };

    const setValue = () => value.value = (focus.value || !props.modelValue) ? props.modelValue : props.decorator(props.modelValue);

    defineExpose({
        focus: () => element.value.focus()
    });

    setValue();

    watch(focus, setValue);

    watch(() => props.modelValue, setValue);
</script>
